import * as angular from 'angular';

"use strict";

angular.module('TemplateModule', [])

export default 'TemplateModule';